import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { PointPositif } from '../models/options/pointsPositifs/pointPositif';

const resource = 'PointsPositifs'

export default class PointsPositifsRessource {
  public async paginatedList(pagenumber?: number, pagesize?: number, search?: string) : Promise<PaginatedList<PointPositif>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
